module.exports = "https://www.gc-qa.gnp.com.mx/beaaca8875f6e2cc6c7b3e33680bcadd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/04-facturas.svg
// module id = 1790
// module chunks = 0